const theme = {
  light: {
    main: "#de393f",
    hoverMain: "#9c2126",
    accent: "#f49000",
    hoverAccent: "#c97700",
    textPrimary: "#ffffff",
    textSecondary: "#d0d0d0",
    grayColor: "#707070",
  },
};

export default theme;
